<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer" ></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '题目1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: ['（1）请在5分钟内，<span class="title_span">尽可能多</span>地提出收集的雨水用途。'],
            durationTime: 5,
            showAnswer: true,
            stemContent: [
              {
                type: 'text',
                value: '水是生命之源，人类和一切动植物都离不开水。资料显示，目前约占世界人口总数40%的80个国家和地区严重缺水，请观看视频。'
              },
              {
                id: 1,
                type: 'video',
                value: [
                  {
                    isControl: false,
                    loop: false,
                    autoPlay: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/stormwater_1_1.mp4'
                  }]
              },
              {
                type: 'text',
                value: '<b>视频资料来源：水资源纪录片《零水日》</b>'
              },
              {
                type: 'text',
                value: '<b>题目1：</b>雨水是我们可以收集、利用的水资源。如果在校园中收集雨水，收集到的雨水可以用来做什么？'
              }
            ],
            askList: [{
              id: 1,
              type: 4,
              config: {
                noneInput: true
              },
              value: '用途'
            }]
          }, {
            id: 2,
            title: '(2)',
            desc: ['（2）请将你想到的雨水用途按类别拖拽到相应的分类框里，如果你想到的用途超出列出的这几类，可以点击“+”添加新的分类框。除了已经想到的这些，你对回收的雨水用途能再提出一些新想法吗？请将新想法添加到相应的分类框里。'],
            durationTime: 3,
            stemContent: [
              // {
              //   type: 'text',
              //   value: '水是生命之源，人类和一切动植物都离不开水。资料显示，目前约占世界人口总数40%的80个国家和地区严重缺水。干旱缺水已成为危机全球粮食安全、人类健康和自然生态系统的重大问题。雨水是一种宝贵的自然资源，如果能对雨水进行合理开发和有效利用，将有助于缓解水资源短缺和干旱频繁的问题。我们如何有效地收集、利用雨水？'
              // },
              // {
              //   type: 'text',
              //   value: '阅读题后，请观看视频'
              // },
              // {
              //   type: 'video',
              //   value: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/54_63071f05109dc/564392482a1f2789120f9b3e3548a9e0.mp4'
              // },
              // {
              //   type: 'text',
              //   value: '<b>题目1：</b>如果开始在校园中收集雨水，收集到的雨水可以用来做什么？'
              // },
              {
                type: 'array'
              }
            ],
            askList: [{
              id: 1,
              type: 8,
              value: '类别',
              maxlength: 7,
              typeList: [
                {
                  title: '清洁',
                  disabled: true,
                  children: []
                },
                {
                  title: '饮用',
                  disabled: true,
                  children: []
                },
                {
                  title: '灌溉',
                  disabled: true,
                  children: []
                }
              ]
            }]
          }
        ]
      }, {
        qid: 2,
        title: '题目2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 9,
            desc: ['（3）请介绍你设计的雨水收集方案具体内容，例如：需要哪些材料或用具，计划如何收集、储存雨水等。如果需要，可以画图说明。'],
            stemContent: [
              {
                type: 'text',
                value: '<b>题目2：</b>请在下面的校园平面图中考察学校校园。选择合适的场所，设计收集雨水的方案。这个方案要合理可行，并且最好是大家平时关注不到或想不到的。'
              },
              {
                type: 'stormwater',
                value: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/image/exam/yi_moren.png',
                imgArr: [
                  {
                    x: '68.5%',
                    y: '41.5%',
                    name: '花坛',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/san_dongmen.mp4',
                    statsName: 'school_flower_bed',
                    // imgUrl: require('@/assets/exam/schoolImg/san_dongmen.png')
                  },
                  {
                    x: '58%',
                    y: '32%',
                    name: '体育馆',
                    // icon: require('@/assets/exam/qizi_icon@2x.png'),
                    // videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/tiyu.mp4',
                    // imgUrl: require('@/assets/exam/schoolImg/tiyu.png')
                  },
                  {
                    x: '38%',
                    y: '28%',
                    name: '学生公寓',
                    // icon: require('@/assets/exam/qizi_icon@2x.png'),
                    // videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xuesheng.mp4',
                    // imgUrl: require('@/assets/exam/schoolImg/xuesheng.png')
                  },
                  {
                    x: '38.5%',
                    y: '41%',
                    name: '道路',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/daolu.mp4',
                    statsName: 'school_road',
                    // imgUrl: require('@/assets/exam/schoolImg/lvdi.png')
                  },
                  {
                    x: '49.5%',
                    y: '43.4%',
                    name: '绿地',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/lvdi.mp4',
                    statsName: 'school_greenbelt'
                    // imgUrl: require('@/assets/exam/schoolImg/lvdi.png')
                  },
                  {
                    x: '30.8%',
                    y: '54.5%',
                    name: '教学楼1',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/jiaoxue_1.mp4',
                    statsName: 'teaching_building_1'
                    // imgUrl: require('@/assets/exam/schoolImg/jiaoxue_1.png')
                  },
                  {
                    x: '25%',
                    y: '60%',
                    name: '教学楼2',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/jiaoxue_2.mp4',
                    statsName: 'teaching_building_2'
                    // imgUrl: require('@/assets/exam/schoolImg/jiaoxue_2.png')
                  },
                  {
                    x: '24%',
                    y: '76%',
                    name: '篮球场',
                    // icon: require('@/assets/exam/qizi_icon@2x.png'),
                    // videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/yundong.mp4',
                    // imgUrl: require('@/assets/exam/schoolImg/yundong.png')
                  },
                  {
                    x: '40%',
                    y: '74%',
                    name: '小湖',
                    // icon: require('@/assets/exam/qizi_icon@2x.png'),
                    // videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xiaohu.mp4',
                    // imgUrl: require('@/assets/exam/schoolImg/xiaohu.png')
                  },
                  {
                    x: '59%',
                    y: '64%',
                    name: '田径场',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/tianjingchang.mp4',
                    statsName: 'school_athletics',
                    // imgUrl: require('@/assets/exam/schoolImg/tianjingchang.png')
                  }
                ]
              },
            ],
            askList: [{
            //   id: 1,
            //   type: 1,
            //   title: '你选择的雨水收集场所是：'
            // }, {
            //   id: 2,
            //   type: 1,
            //   title: '你如何想到这个方案：'
            // }, {
              id: 3,
              type: 1,
              isReview: true,
              noneInput: true
            }, {
              id: 4,
              type: 10,
              title: '如果需要，可采用设计图呈现你的想法。',
              // tip: '你也可以选择将设计图画在下发的答题纸上。'
            }]
          }, {
            id: 4,
            title: '(4)',
            durationTime: 2,
            desc: ['（4）你是受到什么启发想到这个方案的，请具体说明。'],
            stemContent: [
              {
                type: 'text',
                value: '雨水收集方案:'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'text',
                value: '设计图：'
              },
              {
                type: 'draw',
                value: 'img'
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
            }]
          }
        ]
      }, {
        qid: 3,
        title: '题目3',
        small: [
          {
            id: 5,
            title: '(5)',
            stemContent: [
              {
                type: 'text',
                value: '<b>题目3：</b>有的同学为了收集屋顶的雨水，设计了如下雨水收集器，请仔细观察它的结构和不同雨量时的收集效果。'
              },
              {
                type: 'video',
                hasVideoButton: [
                  { text: '小雨' },
                  { text: '中雨' },
                  { text: '大雨' }
                ],
                id: 2,
                value: [
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/adf958707c1edda1eccb124b51374753.mp4',
                    canZoom: true,
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/ce700a63704930a7a6d475eae6a1cf1b.mp4',
                    canZoom: true,
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/c05f357b766e1688b57d3bd75e9be72a.mp4',
                    canZoom: true,
                  }
                ]
              }
            ],
            durationTime: 5,
            desc: ['（5）请分析这个装置是否还有欠缺？如果有，请做出说明。'],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
            }],
          }, {
            id: 6,
            title: '(6)',
            stemContent: [
              // {
              //   type: 'video',
              //   hasVideoSlider: true,
              //   id: 2,
              //   value: [
              //     {
              //       isControl: true,
              //       autoPlay: true,
              //       isloop: true,
              //       url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xiaoyu.mp4'
              //     },
              //     {
              //       isControl: true,
              //       autoPlay: true,
              //       isloop: true,
              //       url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/zhongyu.mp4'
              //     },
              //     {
              //       isControl: true,
              //       autoPlay: true,
              //       isloop: true,
              //       url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/dayu.mp4'
              //     }
              //   ]
              // },
              {
                type: 'video',
                hasVideoButton: [
                  { img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/image/exam/shuitong.png', title: '水桶' },
                  { img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/image/exam/lvwang.png', title: '滤网' },
                  { text: '还能想到……', disabled: true }
                ],
                id: 3,
                value: [
                  // {
                  //   isControl: true,
                  //   autoPlay: true,
                  //   isloop: true,
                  //   url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/dayu.mp4'
                  // },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/stormwater_3_2_1.mp4',
                    canZoom: true
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/stormwater_3_2_2.mp4',
                    canZoom: true
                  },
                  // {
                  //   isControl: true,
                  //   autoPlay: true,
                  //   isloop: true,
                  //   url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/stormwater_3_2_3.mp4'
                  // }
                ]
              }
            ],
            durationTime: 6,
            desc: ['（6）你能想到用什么方法改进这个雨水收集器？先用提供的器材探究一下：点击左侧的器材，试一试。你觉得这两种方法的改进效果如何？你还能想得到哪些方法改进雨水收集器？请在探究和分析的基础上，介绍你最终的改进方案。'],
            askList: [ {
              id: 1,
              type: 1,
              noneInput: true,
            }],
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getAnswer(obj) {
      this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 4,
        subject_name: '雨水',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted() {
    // if (sessionStorage.selectedQidSmall) {
    //   const obj = JSON.parse(sessionStorage.selectedQidSmall)
    //   if (obj.stormwater && Number(obj.stormwater) > 1) {
    //     this.selectedQidSmall = Number(obj.stormwater)
    //   } else {
    //     this.selectedQidSmall = 1
    //   }
    // } else {
    //   this.selectedQidSmall = 1
    // }
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
